import { useMemo } from "react";

export const useImageSize = (setting: string, S: { [key: string]: string }) => {
    const imageSizeClass = useMemo(() => {
        switch (setting) {
            case "WIDE_IMAGE":
                return S.wideImage;
        }
    }, [setting, S]);

    return {
        imageSizeClass,
    };
};
